import { RouteConfig } from 'vue-router';

import ClubEdit from '@/views/club/Edit.vue';

export const clubEditRoute: RouteConfig = {
  path: 'edit',
  name: 'clubEdit',
  component: ClubEdit,
  meta: {
    authorized: true
  }
};
